import React from "react";
import QzTrayCertificateGeneratorForm from "./QzTrayCertificateGeneratorForm";
import QzTrayCertificateDnsTable from "./QzTrayCertificateDnsTable";
import QzTrayCertificateGeneratorActions from "./QzTrayCertificateGeneratorActions";



/**
 * 🔐 QzTrayCertificateGeneratorCard
 *
 * Tarjeta principal para la generación de certificados QZ Tray.
 *
 * Responsabilidades:
 * • Mostrar la introducción del proceso.
 * • Contener el formulario principal.
 * • Mostrar la administración de DNS/IP (Subject Alternative Names).
 * • Mostrar las acciones disponibles.
 *
 * No contiene lógica de negocio.
 */
const QzTrayCertificateGeneratorCard: React.FC = () => {
  return (
    <section className="rounded-xl border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* ============================================================ */}
      {/* Header */}
      {/* ============================================================ */}

      <div className="border-b border-stroke px-6 py-5 dark:border-strokedark">
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-semibold text-black dark:text-white">
            Generar Certificado Digital
          </h2>

          <p className="text-sm text-bodydark2">
            Genere automáticamente un certificado X.509 y una llave privada RSA
            para la firma digital utilizada por QZ Tray.
          </p>
        </div>
      </div>

      {/* ============================================================ */}
      {/* Body */}
      {/* ============================================================ */}

      <div className="space-y-8 p-6">
        {/* Datos principales */}
        <QzTrayCertificateGeneratorForm />

        {/* Subject Alternative Names */}
        {/* <QzTrayCertificateDnsTable /> */}

        {/* Acciones */}
        <QzTrayCertificateGeneratorActions />
      </div>
    </section>
  );
};

export default QzTrayCertificateGeneratorCard;